<div class="main">
    <p class="wrapper">{{time}}</p>
    <div class="circle">
       
    </div>
  </div>